const ANMELDUNG = 'C2_02_03'
const ANMELDUNG_OFFLINE = 'C2_02_03b'
const TICKET = 'Z1_01'

export const TICKETING_CONSTANTS = {
  ANMELDUNG,
  ANMELDUNG_OFFLINE,
  TICKET
}
